<div
  role="dialog"
  aria-labelledby="modalAddEditContactTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalAddEditContactTitle">
          {{ 'kanban.cardForm.title' | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body scroll">
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="card bg-light rounded-3 mb-2">
              <div class="card-body py-2 px-3">
                <div class="d-flex align-items-center gap-3">
                  <div class="flex-grow-1">
                    <div class="d-flex align-items-center gap-2">
                      <div class="custom-switch">
                        <input
                          type="checkbox"
                          id="privacy"
                          [checked]="formGroup.get('isPrivate').value"
                          formControlName="isPrivate"
                          data-switch="danger"
                        />
                        <label for="privacy">
                          <span class="text-muted">
                            {{ 'kanban.cardForm.opportunity' | translate }}

                            {{
                              formGroup.get("isPrivate").value === true
                                ? ('kanban.cardForm.privacyPrivate' | translate)
                                : ('kanban.cardForm.privacyPublic' | translate)
                            }}
                          </span>
                        </label>
                      </div>
                    </div>
                    <small class="text-muted mt-1">
                      {{
                        formGroup.get("isPrivate").value
                          ? ('kanban.cardForm.privacyPrivateHint' | translate)
                          : ('kanban.cardForm.privacyPublicHint' | translate)
                      }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-lg-6 mb-3">
              <label class="form-label">
                {{ 'kanban.cardForm.name' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="name"
                [placeholder]="'kanban.cardForm.namePlaceholder' | translate"
              />
              <field-error-component
                [field]="'name'"
                [label]="'kanban.cardForm.name' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-xs-12 col-md-3 mb-3">
              <label class="form-label">{{ 'kanban.cardForm.priority' | translate }}</label>
              <mat-select formControlName="priority" class="form-control">
                @for (item of priorities; track $index) {
                  <mat-option [value]="item.value">{{ item.label | translate }}</mat-option>
                }
              </mat-select>
            </div>
            <!--
              Temperature is derived from qualification and health (E2 RF-23) — no input.
              The slot carries the inclusion date instead, for deals brought in from
              outside the platform (RF-16); a deal opened from a conversation entered now.
            -->
            @if (isNew && !isCardConverting) {
              <div class="col-xs-12 col-md-3 mb-3">
                <label class="form-label">{{ 'kanban.cardForm.includedAt' | translate }}</label>
                <div class="input-group">
                  <input class="form-control" [matDatepicker]="includedAtPicker" formControlName="includedAt" />
                  <button class="btn btn-light" type="button" (click)="includedAtPicker.open()" [attr.aria-label]="'kanban.nextAction.openCalendar' | translate">
                    <i class="ri-calendar-line"></i>
                  </button>
                </div>
                <mat-datepicker #includedAtPicker></mat-datepicker>
                <small class="text-muted">{{ 'kanban.leadModal.includedAtHint' | translate }}</small>
              </div>
            }
          </div>
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">{{ 'kanban.cardForm.description' | translate }}</label>
              <textarea
                class="form-control scroll"
                formControlName="description"
                [placeholder]="'kanban.cardForm.descriptionPlaceholder' | translate"
                rows="3"
              ></textarea>
            </div>
          </div>

          @if (!!isCardConverting) {
            <div class="row">
              <div class="col-xs-12 col-md-6 mb-3">
                <label class="form-label">{{ 'kanban.cardForm.funnel' | translate }}</label>
                <mat-select formControlName="funnel" class="form-control">
                  <mat-option [value]="null" (click)="searchByFunnel(null)">
                    {{ 'kanban.cardForm.none' | translate }}
                  </mat-option>
                  @for (item of funnels; track $index) {
                    <mat-option
                      [value]="item._id"
                      (click)="searchByFunnel(item)"
                    >
                      {{ item.name }}
                    </mat-option>
                  }
                </mat-select>
                <field-error-component
                  [field]="'funnel'"
                  [label]="'kanban.cardForm.funnel' | translate"
                  [formGroup]="formGroup"
                />
              </div>
              <div class="col-xs-12 col-md-6 mb-3">
                <label class="form-label">{{ 'kanban.cardForm.stage' | translate }}</label>
                <mat-select formControlName="stage" class="form-control">
                  <div class="col-12 input-trend-search p-1"></div>
                  @for (item of funnelStages; track $index) {
                    <mat-option [value]="item._id">{{ item.name }}</mat-option>
                  }
                </mat-select>
                <field-error-component
                  [field]="'stage'"
                  [label]="'kanban.cardForm.stage' | translate"
                  [formGroup]="formGroup"
                />
              </div>
            </div>
          }

          <div class="row">
            <div class="col-xs-12 col-md-4 mb-3">
              <label class="form-label"> {{ 'kanban.cardForm.responsible' | translate }} </label>
              <mat-select
                formControlName="user"
                class="form-control"
                [placeholder]="'kanban.cardForm.responsiblePlaceholder' | translate"
              >
                @for (item of listUser; track $index) {
                  <mat-option [value]="item._id">{{ item.name }}</mat-option>
                }
              </mat-select>
            </div>
            <div class="col-md-5 mb-3">
              <label class="form-label"> {{ 'kanban.cardForm.product' | translate }} </label>
              <mat-select
                formControlName="product"
                class="form-control"
                multiple
                [compareWith]="compareProduct"
                [placeholder]="'kanban.cardForm.productPlaceholder' | translate"
              >
                <div class="overflow-auto" style="max-height: 220px">
                  <div class="col-12 input-trend-search p-1">
                    <input
                      class="form-control"
                      type="text"
                      (click)="$event.stopPropagation()"
                      [placeholder]="'kanban.cardForm.searchProduct' | translate"
                      [formControl]="productControl"
                    />
                    <span class="mdi mdi-magnify search-icon mt-1"></span>
                  </div>
                  @if (listProduct.length === 0) {
                    <mat-option disabled>{{ 'kanban.cardForm.noProductFound' | translate }}</mat-option>
                  }
                  @for (item of listProduct; track $index) {
                    <mat-option [value]="item">{{ item.name }}</mat-option>
                  }
                </div>
                @if (!isAttendant()) {
                  <div class="d-flex justify-content-end p-1 border-top bg-white">
                    <button
                      class="btn btn-outline-light"
                      (click)="
                        $event.stopPropagation();
                        $event.preventDefault();
                        createProduct()
                      "
                    >
                      <i class="mdi mdi-plus me-1"></i>
                      <span>{{ 'kanban.cardForm.newProduct' | translate }}</span>
                    </button>
                  </div>
                }
              </mat-select>
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label"> {{ 'kanban.cardForm.estimatedValue' | translate }} </label>
              <input
                type="text"
                class="form-control"
                formControlName="estimatedValue"
                mask="separator.2"
                thousandSeparator="."
                decimalMarker=","
                prefix="R$ "
                [typeFromDecimals]="true"
                [leadZero]="true"
                [outputTransformFn]="moneyMaskOutput"
                placeholder="R$ 0,00"
              />
            </div>
            <div class="row mt-3">
              <div class="col-xs-12 mb-3">
                <label class="form-label"> {{ 'kanban.cardForm.customer' | translate }} </label>
                <mat-select
                  formControlName="customer"
                  class="form-control"
                  [placeholder]="'kanban.cardForm.customerPlaceholder' | translate"
                >
                  <div class="overflow-auto" style="max-height: 220px">
                    <div class="col-12 input-trend-search p-1">
                      <input
                        class="form-control"
                        type="text"
                        (click)="$event.stopPropagation()"
                        [placeholder]="'kanban.cardForm.searchCustomer' | translate"
                        [formControl]="customerControl"
                      />
                      <span class="mdi mdi-magnify search-icon mt-1"></span>
                    </div>
                    @if (listCustomer.length === 0) {
                      <mat-option disabled
                        >{{ 'kanban.cardForm.noCustomerFound' | translate }}</mat-option
                      >
                    }
                    @for (item of listCustomer; track $index) {
                      <mat-option [value]="item._id">{{
                        item.name
                      }}</mat-option>
                    }
                  </div>
                  <div
                    class="d-flex justify-content-end p-1 border-top bg-white"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-light"
                      (click)="
                        $event.stopPropagation();
                        $event.preventDefault();
                        createCustomer()
                      "
                    >
                      <i class="mdi mdi-plus me-1"></i>
                      <span>{{ 'kanban.cardForm.newCustomer' | translate }}</span>
                    </button>
                  </div>
                </mat-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title mb-3">{{ 'kanban.cardForm.attachFile' | translate }}</h5>

                <div
                  class="upload-area h-40"
                  [ngStyle]="
                    (loadingSpinner$ | async) ? { filter: 'blur(1px)' } : {}
                  "
                  (click)="inputFile.click()"
                >
                  @if (loadingSpinner$ | async) {
                    <loading-component class="loading" diameter="20" />
                  } @else {
                    <div class="placeholder-content">
                      <i
                        class="h2 text-muted mdi mdi-cloud-upload-outline text-primary"
                      ></i>
                      <h5>{{ 'kanban.cardForm.clickToUpload' | translate }}</h5>
                    </div>
                  }
                  <input
                    id="dropzone-file"
                    type="file"
                    class="d-none"
                    (multiple)="(true)"
                    #inputFile
                    (change)="onAttachmentsSelect($event)"
                  />
                </div>
                <div class="dropzone-previews mt-3" id="file-previews"></div>
                <div class="scroll attachment-container">
                  @if (attachments.length > 0) {
                    @for (file of attachments; track $index) {
                      <div class="card mt-1 mb-0 shadow-none border">
                        <div class="p-2">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              @if (isImage(file.filename)) {
                                <img
                                  src="{{ file.url }}"
                                  alt="{{ file.filename }}"
                                  class="avatar-sm rounded"
                                />
                              } @else if (isPDF(file.filename)) {
                                <i
                                  class="h1 text-muted mdi mdi-file-pdf-box"
                                ></i>
                              } @else {
                                <i
                                  class="h1 text-muted mdi mdi-file-outline"
                                ></i>
                              }
                            </div>
                            <div class="col ps-0">
                              <a class="text-muted fw-bold">
                                {{ file.filename }}
                              </a>
                              <p class="small mb-0">
                                {{ formatBytes(file.size) }}
                              </p>
                            </div>
                            <div class="col-auto">
                              <a
                                href="javascript: void(0);"
                                class="btn btn-link btn-lg text-muted"
                                (click)="removeAttachment($index)"
                              >
                                <i
                                  class="ri-close-line text-danger font-24"
                                ></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-light" (click)="close()">
          {{ 'kanban.cardForm.close' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="save()"
          [disabled]="loading"
        >
          @if (loading) {
            <span
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          } @else {
            {{ isNew ? ('kanban.cardForm.save' | translate) : ('kanban.cardForm.update' | translate) }}
          }
        </button>
      </div>
    </div>
  </div>
</div>
